import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionCreators} from '../../data/ActionCreators';
import {Bar} from 'react-chartjs-2';

import {endpoints, http} from '../../configs/http';

import {thousand} from '../../misc/helpers';
import moment from "moment";
import {NavLink} from "react-router-dom";



const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderColor: 'rgba(255,99,132,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(255,99,132,1)',
            data: [65, 59, 80, 81, 56, 55, 40]
        }
    ]
};

const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const thisDate = new Date();

const YEARS = () => {
    let currentYear = new Date().getFullYear();
    let years = [];
    for (var i = currentYear; i >= 2020; i--) {
        years.push(i);
    }
    return years;
};

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            transactions: [],
            year: thisDate.getFullYear(),
            monthlyPaymentList: null,
            totalAmount: null,
            monthsArray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            canShow: false
        };
    }


    updateYear = (event) => {
        this.setState({year: event.target.value});
        console.log(event)

        this.fetchDashboardData(event.target.value)

        this.setState({
            canShow: false,
            monthsArray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        })
    };

    componentDidMount() {
        this.props.getAuthenticated();
        this.props.getPaymentTemplate();
        this.props.getPaymentRequest();
        // this.setupData()
        this.fetchDashboardData(this.state.year);
    }

    fetchDashboardData = (year = thisDate.getFullYear()) => {
        this.setState({


        });
        let url = endpoints.DASHBOARD_DATA.replace(':year', year);

        http
            .get(url)
            .then(async (resp) => {
                console.log(Object.keys(resp).length);
                console.log(resp);
                if (Object.keys(resp).length !== 0 && resp.constructor === Object) {
                    console.log('yes');
                    this.setState({
                        monthlyPaymentList: resp.monthlyPaymentList,
                        totalAmount: resp.totalAmount,
                        canShow: true,
                    });

                    this.setupData(resp.monthlyPaymentList);
                } else {
                    console.log('no');
                    this.setState({
                        monthlyPaymentList: null,
                        totalAmount: null,
                        canShow: true,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({
                    isFetching: false,

                });
                let errorMessage =
                    (typeof err === 'string' && err) ||
                    'An error occured, please try again in a moment.';
                // alert(JSON.stringify(error));
                console.log(errorMessage);
                // this.setState({
                //   snacksMessage: errorMessage,
                //   showMessage: true,
                //   errorMessage: errorMessage,
                // });
            });
    };

    setupData(lists) {

        var monthsArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        lists.forEach(getSections);
        function getSections(item, index) {
            console.log(item.month)
            if (item.month === 'January') {
                monthsArray[0] = parseInt(item.amount);
            } else if (item.month === 'February') {
                monthsArray[1] = parseInt(item.amount);
            }
            else if (item.month === 'March') {
                monthsArray[2] = parseInt(item.amount);
            }
            else if (item.month === 'April') {
                monthsArray[3] = parseInt(item.amount);
            }
            else if (item.month === 'May') {
                monthsArray[4] = parseInt(item.amount);
            }
            else if (item.month === 'June') {
                monthsArray[5] = parseInt(item.amount);
            }
            else if (item.month === 'July') {
                monthsArray[6] = parseInt(item.amount);
            }
            else if (item.month === 'August') {
                monthsArray[7] = parseInt(item.amount);
            }
            else if (item.month === 'September') {
                monthsArray[8] = parseInt(item.amount);
            }
            else if (item.month === 'October') {
                monthsArray[9] = parseInt(item.amount);
            }
            else if (item.month === 'November') {
                monthsArray[10] = parseInt(item.amount);
            }
            else if (item.month === 'December') {
                monthsArray[11] = parseInt(item.amount);
            }
        }
        this.setState({
            monthsArray
        })
        console.log(monthsArray);
    }

    getMonth(){
        if (thisDate.getMonth() == 0){
            return "January"
        }
        else {
            return "Jan - "+ monthNames[thisDate.getMonth()].substring(0,3)
        }
    }
    // setupData(){
    //     var gridLineColor = 'rgba(77, 138, 240, .1)';
    //     // Monthly sales chart start
    //     if(true) {
    //         var monthlySalesChart = document.getElementById('monthly-sales-chart').getContext('2d');
    //         new Chart(monthlySalesChart, {
    //                 type: 'bar',
    //                 data: {
    //                     labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    //                     datasets: [{
    //                         label: 'Sales',
    //                         data: [150,110,90,115,125,160,190,140,100,110,120,120],
    //                         backgroundColor: "#10b759"
    //                     }]
    //                 },
    //                 options: {
    //                     maintainAspectRatio: false,
    //                     legend: {
    //                         display: false,
    //                         labels: {
    //                             display: false
    //                         }
    //                     },
    //                     scales: {
    //                         xAxes: [{
    //                             display: true,
    //                             barPercentage: .3,
    //                             categoryPercentage: .6,
    //                             gridLines: {
    //                                 display: false
    //                             },
    //                             ticks: {
    //                                 fontColor: '#8392a5',
    //                                 fontSize: 10
    //                             }
    //                         }],
    //                         yAxes: [{
    //                             gridLines: {
    //                                 color: gridLineColor
    //                             },
    //                             ticks: {
    //                                 fontColor: '#8392a5',
    //                                 fontSize: 10,
    //                                 min: 80,
    //                                 max: 200
    //                             }
    //                         }]
    //                     }
    //                 }
    //             }
    //         );
    //     }
    // }

    getColor(status) {
        if (status == 'INITIATED') {
            return "#85bfde";
        } else if (status == 'PENDING') {
            return "#E6A40B";
        } else if (status == 'SUCCESS' || status == 'APPROVED') {
            return "#229858";
        } else if (
            status == 'CANCELLED' ||
            status == 'DECLINED' ||
            status == 'FAILED'
        ) {
            return "#ff5230";
        }
        return "#000000";
    }

    getRowsData = function() {
        const {data} = this.props.recentPayments;
        return data.map((item, index) => {
            return (
                <tr key={index}>
                    {/*<td>{index + 1}</td>*/}
                    <td>{`₦${thousand(parseInt(item.amount))}`}</td>

                    <td>    {item.paymentRequestType} {item.paymentType.name} Payment </td>
                    <td>           <span
                        style={

                            {color: this.getColor(item.status)}
                        }>
                        {item.status}
                    </span>
                    </td>
                    <td>   {moment(item.dateOf).format('MMMM Do YYYY')}</td>


                </tr>
            );
        });
    };


    render() {
        const {monthlyPaymentList,monthsArray, totalAmount, canShow} = this.state;
        const {data} = this.props.recentPayments;
        return (
            <div>




                <div className="row">
                    <div className="col-lg-7 col-xl-8 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-baseline mb-2">
                                    <h6 className="card-title mb-0">Yearly payment analysis</h6>
                                    <div className="dropdown mb-2">
                                        <select value={this.state.year}    onChange={(val) => {
                                            this.updateYear(val)
                                        }}>
                                            {YEARS().map(item =>
                                                <option key={item} value={item}>{item.toString()}</option>
                                            )};

                                        </select>
                                        {/*<button className="btn p-0" type="button" id="dropdownMenuButton4"*/}
                                        {/*        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">*/}
                                        {/*    <i className="icon-lg text-muted pb-3px" data-feather="more-horizontal"></i>*/}
                                        {/*</button>*/}
                                        <div className="dropdown-menu dropdown-menu-right"
                                             aria-labelledby="dropdownMenuButton4">
                                            <a className="dropdown-item d-flex align-items-center" href="#"><i
                                                data-feather="eye" className="icon-sm mr-2"></i> <span
                                                className="">View</span></a>
                                            <a className="dropdown-item d-flex align-items-center" href="#"><i
                                                data-feather="edit-2" className="icon-sm mr-2"></i> <span
                                                className="">Edit</span></a>
                                            <a className="dropdown-item d-flex align-items-center" href="#"><i
                                                data-feather="trash" className="icon-sm mr-2"></i> <span
                                                className="">Delete</span></a>
                                            <a className="dropdown-item d-flex align-items-center" href="#"><i
                                                data-feather="printer" className="icon-sm mr-2"></i> <span
                                                className="">Print</span></a>
                                            <a className="dropdown-item d-flex align-items-center" href="#"><i
                                                data-feather="download" className="icon-sm mr-2"></i> <span
                                                className="">Download</span></a>
                                        </div>
                                    </div>
                                </div>
                                <p className="text-muted mb-4">Check out how you have been able to spread your payments</p>
                                <div className="monthly-sales-chart-wrapper">
                                    {/*<canvas id="monthly-sales-chart"></canvas>*/}
                                    <Bar
                                        data={{
                                            labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
                                            datasets: [{
                                                label: 'Payments',
                                                data: !monthlyPaymentList
                                                    ? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                                                    : monthsArray,
                                                backgroundColor: '#10b759'
                                            }]
                                        }}
                                        width={100}
                                        height={50}
                                        options={{
                                            maintainAspectRatio: false,
                                            legend: {
                                                display: false,
                                                labels: {
                                                    display: false
                                                }
                                            },
                                            scales: {
                                                xAxes: [{
                                                    display: true,
                                                    barPercentage: .3,
                                                    categoryPercentage: .6,
                                                    gridLines: {
                                                        display: false
                                                    },
                                                    ticks: {
                                                        fontColor: '#8392a5',
                                                        fontSize: 10
                                                    }
                                                }],
                                                yAxes: [{
                                                    gridLines: {
                                                        color: 'rgba(77, 138, 240, .1)'
                                                    },
                                                    ticks: {
                                                        fontColor: '#8392a5',
                                                        fontSize: 10,

                                                    }
                                                }]
                                            }
                                        }}

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5 col-xl-4 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-baseline mb-2">
                                    <h6 className="card-title mb-0">Want More?</h6>
                                    <div className="dropdown mb-3">

                                    </div>
                                </div>


                                        You have paid

                                    {canShow ?
                                        <div>
                                            {totalAmount ?
                                                <h3 className="mb-2 text-primary" >₦{thousand(totalAmount)}</h3>

                                                :
                                                <h3 className="mb-2 text-primary" >
                                                    ₦0
                                                </h3>
                                            }
                                        </div>

                                        :

                                        <div>---</div>
                                    }
                                    {this.state.year !== thisDate.getFullYear() ?
                                        <div>
                                            For the month of <span style={{color: 'green'}}>Jan - Dec</span>{' '}
                                            {this.state.year}
                                        </div>
                                        :
                                        <div>
                                            For the month of <span style={{color: 'green'}}>{this.getMonth()}</span>{' '}
                                            {this.state.year}
                                        </div>
                                    }


                                <NavLink to="/pay" className="btn btn-primary btn-block mt-5">Make New Payment</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
                {data &&
                <div className="row">
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">

                            <div className="card-body">
                                <h6 className="card-title">Payment Requests</h6>
                                <p className="card-description">Track your most recent transactions</p>
                                <div className="table-responsive">
                                    <table id="dataTableExample" className="table">
                                        <thead>
                                        <tr>
                                            <th>Amount</th>
                                            <th>Type</th>
                                            <th>Status</th>
                                            <th>Date</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {this.getRowsData()}

                                        {/*<tr>*/}
                                        {/*    <td>1</td>*/}
                                        {/*    <td>Sedncash</td>*/}
                                        {/*    <td>Transaction</td>*/}
                                        {/*    <td>Activated</td>*/}
                                        {/*</tr>*/}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }

            </div>
        );
    }
}



// map store state to component props
const mapStateToProps = (state) => {
    // get required state from store state
    var {auth, recentPayments} = state;
    // return state
    return {
        auth,
        recentPayments,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            getAuthenticated: ActionCreators.getAuthenticated,
            getPaymentRequest: ActionCreators.getRecentPayments,
            getPaymentTemplate: ActionCreators.getPaymentTemplate,
        },
        dispatch,
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);

